<template>
  <div class="kjqg">
    <div class="kjqg-header" v-if="$route.path.indexOf('kjqgIndex') == -1 ">
      <div class="header-info">
        <div class="info-l">
          <img v-if="schoolInfo" :src="schoolInfo.school_logo" class="info-title">
          <div class="split-line"></div>
          <img src="../../assets/image/common/szzyk.png" class="info-subtitle">
        </div>
        <div v-if="appsUserInfo && appsUserInfo.name" class="login-dropdown-box">
          <div class="login-after">{{ appsUserInfo.name }}</div>
          <div class="login-sub-box">
            <template v-if="
                appsUserInfo.user_type == 2 ||
                (appsUserInfo.user_type == 1 && appsUserInfo.role_ids)
              ">
              <div class="hover-item">
                <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/school/resource`" target="_blank">校内共建资源库</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/resource`" target="_blank">备课资源库</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/works`" target="_blank">协同备课</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/favorite`" target="_blank">资源收藏</a>
              </div>
            </template>
            <template v-if="
                appsUserInfo.user_type == 2 ||
                (appsUserInfo.user_type == 1 && appsUserInfo.role_ids == 2)
              ">
              <div class="hover-item">
                <a :href="`${services.BEIKE_SERVER}/${school_code}/manage/user`" target="_blank">用户管理</a>
              </div>
            </template>
            <div class="login-lines"></div>
            <div class="hover-item">
              <a :href="`${services.APPS_WEB}/${school_code}/worker`" target="_blank">信息服务中心</a>
            </div>
            <div class="hover-item">
              <a :href="`${services.APPS_WEB}/${school_code}/userInfo`" target="_blank">个人信息设置</a>
            </div>
            <div v-if="!isMobile" class="hover-item">
              <a :href="`${services.APPS_WEB}/${school_code}/editPassword`" target="_blank">修改密码</a>
            </div>
            <div class="hover-item" @click="logoutEvent">
              <a href="javascript:;">退出</a>
            </div>
          </div>
        </div>
      </div>
      <div class="header-nav">
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/kjqgIndex`)">
          <div class="item-text">
            <div class="text-title">首页</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/zcqdkc`)" :class="{active: currentPath.indexOf('zcqdkc') >= 0 || $route.query.columnPath == 'zcqdkc'  }">
          <div class="item-text">
            <div class="text-title">政策驱动科创</div>
            <div class="text-subtitle">学 政 策</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/bnkjhz?ind=0`)" :class="{active: currentPath.indexOf('bnkjhz') >= 0 || $route.query.columnPath == 'bnkjhz'  }">
          <div class="item-text">
            <div class="text-title">百年科技华章</div>
            <div class="text-subtitle">明 历 史</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/qycxzf?ind=0`)" :class="{active: currentPath.indexOf('qycxzf') >= 0 || $route.query.columnPath == 'qycxzf'  }">
          <div class="item-text">
            <div class="text-title">前沿创新争锋</div>
            <div class="text-subtitle">探 前 沿</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/kjfwms?ind=0`)" :class="{active: currentPath.indexOf('kjfwms') >= 0 || $route.query.columnPath == 'kjfwms'  }">
          <div class="item-text">
            <div class="text-title">科技服务民生</div>
            <div class="text-subtitle">促 应 用</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/zykjyr`)" :class="{active: currentPath.indexOf('zykjyr') >= 0  }">
          <div class="item-text">
            <div class="text-title">专业科技育人</div>
            <div class="text-subtitle">育 人 才</div>
          </div>
        </div>
        <div class="nav-item" @click="$router.push(`/${school_code}/kjqg/kcjsgm?ind=0`)" :class="{active: currentPath.indexOf('kcjsgm') >= 0 || $route.query.columnPath == 'kcjsgm'  }">
          <div class="item-text">
            <div class="text-title">科创精神共鸣</div>
            <div class="text-subtitle">悟 精 神</div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <Login></Login>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Login from "../../components/Login.vue";
import services from "../../assets/js/services";
import utils from "../../assets/js/utils";
export default {
  components: {
    Login,
  },
  data() {
    return {
      services,
      isMobile: utils.isMobile(),
      school_code: localStorage.getItem("schoolCode"),
    }
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
      loginVisible: state => state.appsLogin.loginVisible,
      keyWord: state => state.search.keyWord,
      loading: state => state.search.loading,
      schoolInfo: state => state.appsLogin.schoolInfo
    }),
    currentPath() {
      return this.$route.path
    }
  },
  methods: {
    ...mapMutations([
      "setSearchKeyWord",
      "setAppsLoginVisible",
      "setSearchSzzykData",
      "setSearchElementData",
      "resetSzzykTotal",
    ]),
    ...mapActions([
      "getAppsImageCaptcha",
      "getLoginSchoolInfo",
      "getAppsLoginUserInfo",
      "requestAppsLogout",
      "goAppsDetailsBeforeLogin",
      "schoolLoginRedirect",
    ]),

    async logoutEvent() {
      let that = this;
      await that.requestAppsLogout().then(() => {
        this.$message.success("已退出登录")
        this.$router.push(`/${this.school_code}/kjqg`)
      })
    },
  },
  mounted(){
    this.getLoginSchoolInfo({ school_code: this.school_code, label: 'kcsz' })
  }
}
</script>
<style lang="less" >
.fixed-aside-box:has(+ .kjqg) {
  display: none;
}
</style>
<style lang="less" scoped >
.kjqg-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  .header-info {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .info-l {
      padding: 10px 0;
      display: flex;
      align-items: center;
      .info-title {
        width: auto;
        height: 25px;
      }
      .info-subtitle {
        width: auto;
        height: 17px;
      }
      .split-line {
        width: 1px;
        height: 17px;
        background: #e6e3e3;
        margin: 0 20px;
        display: inline-block;
      }
    }
    .login-dropdown-box {
      margin-left: 35px;
      height: 32px;
      line-height: 32px;
      position: relative;
      display: inline-block;
      .login-after {
        color: #121212;
        font-size: 12px;
        display: inline-block;
        line-height: 30px;
        &::after {
          display: inline-block;
          content: "";
          width: 7px;
          height: 5px;
          margin-left: 5px;
          background-image: url("../../assets/image/common/up-icon.png");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% auto;
          vertical-align: 3px;
          transition: background-image 0.3s;
        }
      }
      .login-sub-box {
        display: none;
        position: absolute;
        padding: 10px 20px;
        box-sizing: border-box;
        top: 30px;
        left: -35px;
        width: 140px;
        text-align: left;
        background-color: transparent;
        box-shadow: 0px 1px 6px 0px rgba(130, 130, 130, 0.2);
        border-radius: 2px;
        transition: background-color 0.3s;
        z-index: 100;
        .hover-item {
          display: block;
          line-height: 26px;
          &:hover {
            background-color: #fff;
          }
          a {
            color: #393939;
            font-size: 12px;
            display: block;
            &:hover {
              color: #e64757;
              background-color: #fff;
            }
          }
        }
        .login-lines {
          width: 100%;
          height: 1px;
          background: #f3f4f5;
          margin: 5px 0;
        }
      }
      &:hover .login-after::after {
        background-image: url("../../assets/image/common/down-icon.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center;
      }
      &:hover .login-sub-box {
        display: block;
        background-color: #ffffff;
      }
    }
  }
  .header-nav {
    display: flex;
    height: 3.64vw;
    background: linear-gradient(90deg, #1579e6 0%, #1865e4 100%);
    border: 1px solid #6fcaff;
    .nav-item {
      // flex: 1;
      display: flex;
      align-items: center;
      height: 100%;
      padding-right: 0.3vw;
      &.active {
        .item-text {
          background: #125ccc;
        }
      }
      &:first-child {
        .item-text {
          width: 13.4vw;
        }
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
      &::after {
        content: "";
        display: block;
        width: 1.78vw;
        background-image: url("../../assets/image/kjqg/common/nav-split.png");
        background-size: cover;
        height: 2.18vw;
        margin-left: 0.4vw;
      }
      .item-text {
        width: 11.78vw;
        text-align: center;
        height: 100%;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          background: #125ccc;
        }
        .text-title {
          font-weight: bold;
          font-size: 0.8vw;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
        }
        .text-subtitle {
          font-weight: bold;
          font-size: 0.7vw;
          color: #ffcba9;
        }
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .text-title {
    font-size: 1vw !important;
  }
  .text-subtitle {
    font-size: .8vw !important;
  }
}
</style>